import { STATUS } from "#candidate/constants"
import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdFileGet, candidateIdPut } from "#candidate/services/api"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { DialogMaster } from "#core/components/dialog/Dialog"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { Box, Button, Typography } from "@mui/material"
import { Fragment, useCallback, useMemo, useState } from "react"

export default function CandidateStatusBossInterview() {
	const { candidateId, candidate } = useCandidateRedux()
	const [open, setOpen] = useState(false)
	const [disabled, setDisabled] = useState(false)

	const { refresh } = useRefreshCandidate()

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdPut, { success, end })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, {
			status: STATUS.FINAL_CANDIDATE,
		})
	}, [candidateId, fetch])

	return (
		<Fragment>
			<Button onClick={() => setOpen(!open)}>Candidato Final</Button>
			<DialogMaster
				{...{
					title: "candidato final",
					open,
					setOpen,
					handleSubmit,
					disabled,
					maxWidth: "sm",
					disabledSubmit: disabled,
				}}
			>
				<Box display="flex" flexDirection="column" gap={2} alignItems={"center"}>
					<CandidateFiles open={open} candidate={candidate} />
				</Box>
			</DialogMaster>
		</Fragment>
	)
}

const CandidateFiles = ({ open, candidate }) => {
	const { candidateId } = useCandidateRedux()
	const params = useMemo(
		() => ({ id: candidateId, params: { check_files: true } }),
		[candidateId]
	)
	const { data, loading, error } = useApi(candidateIdFileGet, { params, autoFetch: open })

	const items = useMemo(() => {
		if (data?.count === 0) return null
		return data?.data.map((file) => <li key={file}>{file}</li>)
	}, [data?.count, data?.data])

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Fragment>
			<Typography variant="h6" align="center">
				Se pasara a <strong>{candidate.candidate_name}</strong> como candidato final.
			</Typography>
			{items && (
				<Fragment>
					<Typography variant="body1" align="center">
						Para este perfil, se han detectado los siguientes archivos pendientes:
					</Typography>
					<lo>{items}</lo>
					<Typography variant="body1" align="center">
						¿Deseas continuar?
					</Typography>
				</Fragment>
			)}
		</Fragment>
	)
}
